import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgInfo = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	color: "#0f1826",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M8 1C11.866 1 15 4.13401 15 8C15 11.866 11.866 15 8 15C4.13401 15 1 11.866 1 8C1 4.13401 4.13401 1 8 1ZM8 2C4.68629 2 2 4.68629 2 8C2 11.3137 4.68629 14 8 14C11.3137 14 14 11.3137 14 8C14 4.68629 11.3137 2 8 2ZM8 7.125C8.36244 7.125 8.65625 7.41881 8.65625 7.78125V10.8438C8.65625 11.2062 8.36244 11.5 8 11.5C7.63756 11.5 7.34375 11.2062 7.34375 10.8438V7.78125C7.34375 7.41881 7.63756 7.125 8 7.125ZM8 4.71875C8.36244 4.71875 8.65625 5.01256 8.65625 5.375C8.65625 5.73744 8.36244 6.03125 8 6.03125C7.63756 6.03125 7.34375 5.73744 7.34375 5.375C7.34375 5.01256 7.63756 4.71875 8 4.71875Z",
		fill: "currentColor"
	})
});
export default SvgInfo;
